import * as React from 'react'
import { countUp } from './CountUp'

const GDTable = ({ className, title, stats }): React.ReactElement => {
  return (
    <div className={`${className} white-background`}>
      <h2>{title}</h2>
      <table className="global-dashboard__table">
        <tbody>
        {Object.keys(stats).map((key, index) => (
          <tr key={`cases-${key}-${index}`}>
            <td>{key}</td>
            <td>{countUp(stats[key])}</td>
          </tr>
        ))}
        </tbody>
      </table>
    </div>
  )
}

export default React.memo(GDTable);
